/* Unlock theme by Zeris · behaviour. No dependencies. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const routes = (window.theme && window.theme.routes) || { root: '/', cart: '/cart' };

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Drawers and dialogs ---------- */
  function openDialog(dialog, opener) {
    if (!dialog || dialog.open) return;
    dialog._opener = opener || document.activeElement;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }
  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }
  document.addEventListener('close', (e) => {
    if (!(e.target instanceof HTMLDialogElement)) return;
    document.documentElement.style.overflow = '';
    const opener = e.target._opener;
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (document.contains(opener)) opener.focus();
    }
  }, true);

  document.addEventListener('click', (e) => {
    const t = e.target;
    // click on the backdrop closes the dialog
    if (t instanceof HTMLDialogElement && t.open) {
      const r = t.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDialog(t);
      return;
    }
    const closer = t.closest('[data-drawer-close], [data-dialog-close]');
    if (closer) return closeDialog(closer.closest('dialog'));

    const menu = t.closest('[data-menu-open]');
    if (menu) return openDialog($('#MenuDrawer'), menu);

    const filter = t.closest('[data-filter-open]');
    if (filter) return openDialog($('#FilterDrawer'), filter);

    const dialogOpener = t.closest('[data-dialog-open]');
    if (dialogOpener) return openDialog(document.getElementById(dialogOpener.dataset.dialogOpen), dialogOpener);

    const cartLink = t.closest('[data-cart-open]');
    if (cartLink && window.theme.cartType === 'drawer' && $('#CartDrawer')) {
      e.preventDefault();
      return openDialog($('#CartDrawer'), cartLink);
    }
  });

  /* ---------- Header ----------
     Normal pages: in the flow at the top; scrolling down it leaves with the page, scrolling
     up brings it back pinned (fade in, matte glass). Home with a hero: pinned and transparent
     over the hero (the big logo glides into it), then the same down/up behaviour after the hero. */
  function initHeader() {
    const header = $('[data-header]');
    if (!header) return;
    const section = header.closest('.section-header');
    const root = document.documentElement;
    const overHero = header.hasAttribute('data-over-hero');
    const first = $('#MainContent > .shopify-section:first-child');
    const hero = overHero && first && first.querySelector('[data-hero]') ? first : null;
    if (overHero && !hero) header.classList.add('is-solid');
    const pinOnScrollUp = header.classList.contains('header--sticky');
    // sticky without "hide on scroll": the header simply stays at the top the whole time
    const keep = pinOnScrollUp && !header.hasAttribute('data-hide-on-scroll');
    if (keep) section.classList.add('is-pinned');
    let lastY = window.scrollY;
    let leaveTimer = null;

    const visibleHeight = () => {
      const r = section.getBoundingClientRect();
      return Math.max(0, Math.min(r.bottom, header.offsetHeight));
    };
    const setOffset = () => {
      root.style.setProperty('--header-h', header.offsetHeight + 'px');
      root.style.setProperty('--header-offset', (section.classList.contains('is-leaving') ? 0 : visibleHeight()) + 'px');
    };
    const stick = () => {
      clearTimeout(leaveTimer);
      section.classList.remove('is-leaving');
      if (!section.classList.contains('is-stuck')) section.classList.add('is-stuck');
      header.classList.add('is-glass');
    };
    const unstick = () => {
      if (!section.classList.contains('is-stuck') || section.classList.contains('is-leaving')) return;
      if (document.querySelector('dialog[open]') || section.contains(document.activeElement)) return;
      section.classList.add('is-leaving');
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(() => {
        section.classList.remove('is-stuck', 'is-leaving');
        header.classList.remove('is-glass');
        setOffset();
      }, 130);
    };

    const update = () => {
      const y = window.scrollY;
      const h = header.offsetHeight;
      const goingUp = y < lastY - 3;
      const goingDown = y > lastY + 3;
      if (hero) {
        // stay clear (white logo) until the hero has gone past the middle of the header;
        // a header that never hides turns to glass as soon as the page moves instead,
        // so the hero words never slide under the clear white menu
        const heroEnd = hero.offsetHeight - h / 2;
        const inHero = keep ? y < 8 : y < heroEnd;
        header.classList.toggle('is-solid', !inHero);
        if (inHero) {
          // pinned and transparent while the hero is on screen
          clearTimeout(leaveTimer);
          section.classList.remove('is-leaving');
          section.classList.add('is-stuck');
          header.classList.remove('is-glass');
        } else if (keep) stick();
        else if (goingDown) unstick();
        else if (goingUp && pinOnScrollUp) stick();
      } else if (keep) {
        header.classList.toggle('is-glass', y > 0);
      } else if (y <= h) {
        // back at the top: header sits in the page flow again
        clearTimeout(leaveTimer);
        section.classList.remove('is-stuck', 'is-leaving');
        header.classList.remove('is-glass');
      } else if (goingDown) unstick();
      else if (goingUp && pinOnScrollUp) stick();
      if (Math.abs(y - lastY) > 3) lastY = y;
      setOffset();
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', setOffset);
    update();
  }

  /* ---------- Logo cycle ----------
     Frames are the alternate logos followed by the main logo.
     "always" loops forever (like an animated GIF logo); "load" plays N loops then
     settles on the main logo; "hover" loops while hovered. */
  function initLogoCycle() {
    $$('[data-logo-cycle]').forEach((stack) => {
      const alts = $$('.logo__img--alt', stack);
      const main = $('.logo__img--main', stack);
      if (!alts.length || !main || reduceMotion) return;
      const frames = [...alts, main];
      const speed = parseInt(stack.dataset.speed, 10) || 250;
      const loops = parseInt(stack.dataset.loops, 10) || 2;
      const trigger = stack.dataset.trigger || 'always';
      let timer = null;

      const show = (i) => frames.forEach((f, n) => f.classList.toggle('is-active', n === i));
      const stop = () => {
        clearInterval(timer);
        timer = null;
        frames.forEach((f) => f.classList.remove('is-active'));
        stack.classList.remove('is-cycling');
      };
      let locked = false;
      const play = (infinite) => {
        if (timer || locked) return;
        let step = 0;
        const total = frames.length * loops;
        stack.classList.add('is-cycling');
        show(0);
        timer = setInterval(() => {
          step += 1;
          if (!infinite && step >= total) return stop();
          show(step % frames.length);
        }, speed);
      };

      // hero intro: flick through the logos fast like switching channels, then lock on the main one
      document.addEventListener('logo:fast', () => {
        stop();
        locked = false;
        stack.classList.add('is-cycling');
        let i = 0;
        show(0);
        timer = setInterval(() => {
          i = (i + 1) % frames.length;
          show(i);
        }, speed);
      });
      document.addEventListener('logo:lock', () => {
        stop();
        locked = true;
      });
      document.addEventListener('logo:release', () => {
        locked = false;
        if (trigger === 'always') play(true);
      });

      if (trigger === 'hover') {
        const link = stack.closest('a');
        link.addEventListener('mouseenter', () => play(true));
        link.addEventListener('mouseleave', stop);
      } else {
        // 'intro': stays on the main logo; it only flicks during the home page intro
        const start = () => trigger !== 'intro' && play(trigger === 'always');
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, { once: true });
      }
    });
  }

  /* ---------- Hero: video, shrink, parallax, sound ---------- */
  function initHero() {
    const hero = $('[data-hero]');
    if (!hero) return;
    // hero intro: over after the CSS has played, or straight away if the page isn't at the top
    const root = document.documentElement;
    if (root.classList.contains('hero-intro')) {
      const end = () => root.classList.remove('hero-intro');
      if (!$('.hero__veil', hero) || window.scrollY > 40) end();
      else {
        setTimeout(end, 4500);
        window.addEventListener('scroll', end, { once: true, passive: true });
      }
    }
    const videos = $$('[data-hero-video]', hero);
    if (videos.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          const v = en.target;
          if (en.isIntersecting && !reduceMotion) v.play().catch(() => {});
          else v.pause();
        });
      });
      videos.forEach((v) => {
        v.muted = true;
        // start the clip that is actually shown (desktop or mobile) right away;
        // the observer only pauses and resumes it while scrolling
        if (!reduceMotion && v.offsetParent !== null) v.play().catch(() => {});
        io.observe(v);
      });
    }

    const sound = $('[data-hero-sound]', hero);
    if (sound) {
      sound.addEventListener('click', () => {
        const v = videos.find((x) => x.offsetParent !== null);
        if (!v) return;
        v.muted = !v.muted;
        sound.setAttribute('aria-pressed', String(!v.muted));
        sound.textContent = v.muted ? 'Sound off' : 'Sound on';
      });
    }

    if (reduceMotion) return;
    const shrink = hero.hasAttribute('data-hero-shrink');
    const parallax = hero.classList.contains('hero--parallax');
    if (!shrink && !parallax) return;
    const media = $('.hero__media', hero);
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = hero.getBoundingClientRect();
      if (r.bottom < 0) return;
      const p = Math.min(1, Math.max(0, -r.top / (r.height * 0.8)));
      if (shrink) hero.style.setProperty('--p', p.toFixed(3));
      if (parallax) media.style.transform = `translate3d(0, ${(-r.top * 0.25).toFixed(1)}px, 0)`;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  /* ---------- Collection: sort, columns, filters ---------- */
  function initCollection() {
    const section = $('[data-collection]');
    if (!section) return;
    const form = $('[data-collection-form]', section);
    const sort = $('[data-sort]', section);
    if (sort) sort.addEventListener('change', () => form.submit());

    const KEY = 'unlock:cols';
    const apply = (n) => {
      section.style.setProperty('--cols', n);
      $$('[data-cols]', section).forEach((b) => {
        const on = b.dataset.cols === String(n);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
    };
    try {
      const saved = localStorage.getItem(KEY);
      if (saved) apply(saved);
    } catch (e) {}
    $$('[data-cols]', section).forEach((b) =>
      b.addEventListener('click', () => {
        apply(b.dataset.cols);
        try {
          localStorage.setItem(KEY, b.dataset.cols);
        } catch (e) {}
      })
    );
  }

  /* ---------- Product: variants, gallery counter ---------- */
  function initProduct(root = $('[data-product]')) {
    if (!root || root._productReady) return;
    root._productReady = true;
    const data = JSON.parse($('[data-product-json]', root).textContent);
    const form = $('[data-product-form]', root);
    const idInput = form && $('[data-variant-id]', form);
    const addBtn = form && $('[data-add-button]', form);
    const addLabel = form && $('[data-add-label]', form);
    const strings = { add: addLabel ? addLabel.textContent.trim() : 'Add to cart' };

    const currentOptions = () =>
      $$('[data-variant-picker] fieldset', root).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });

    const markAvailability = () => {
      const selected = currentOptions();
      $$('[data-variant-picker] input', root).forEach((input) => {
        const idx = Number(input.dataset.optionIndex);
        const test = selected.slice();
        test[idx] = input.value;
        const match = data.variants.find((v) => v.options.every((o, i) => o === test[i]));
        input.closest('.variants__pill').classList.toggle('is-unavailable', !match || !match.available);
      });
    };

    const onChange = () => {
      const selected = currentOptions();
      selected.forEach((val, i) => {
        const label = $(`[data-option-value="${i}"]`, root);
        if (label) label.textContent = val;
      });
      const variant = data.variants.find((v) => v.options.every((o, i) => o === selected[i]));
      markAvailability();
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? strings.add : 'Sold out';
      const price = $('[data-price] .price__current', root);
      if (price) price.textContent = variant.price;
      const compare = $('[data-price] .price__compare', root);
      if (compare) compare.textContent = variant.compare || '';
      // only the real product page owns the URL; the quick view must not rewrite it
      if (!root.hasAttribute('data-quick')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, selected } }));
    };
    $$('[data-variant-picker] input', root).forEach((i) => i.addEventListener('change', onChange));
    markAvailability();

    initGallery(root);
    initBuyBar(root);
  }

  /* ---------- Sticky buy bar: on phones, shown whenever the main button is off screen ---------- */
  function initBuyBar(root) {
    const bar = $('[data-buy-bar]', root);
    const main = $('[data-add-button]', root);
    if (!bar || !main) return;
    const io = new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      $('[data-buy-bar-button]', bar).tabIndex = show ? 0 : -1;
    });
    io.observe(main);
    document.addEventListener('variant:change', (e) => {
      const v = e.detail.variant;
      $('[data-buy-bar-price]', bar).textContent = v.price;
      $('[data-buy-bar-button]', bar).disabled = !v.available;
    });
  }

  /* ---------- Product gallery ----------
     stage (desktop): the sticky frame swaps images as the page scrolls past the gallery.
     stack (desktop): full-height images; the one most in view is "current".
     stage works on every screen: scrolling down slides the photos across a frame that stays in view.
     stack on phones/tablets: horizontal swipe. Dots jump to an image in every mode. */
  function initGallery(root) {
    const gallery = $('[data-gallery]', root);
    if (!gallery) return;
    const items = $$('.gallery__item', gallery);
    const track = $('[data-gallery-track]', gallery);
    const dots = $$('[data-gallery-go]', gallery);
    const counter = $('[data-gallery-current]', gallery);
    const desktop = window.matchMedia('(min-width: 990px)');
    const isStage = () => gallery.dataset.galleryStyle === 'stage';
    let current = 0;

    const setCurrent = (i) => {
      if (i === current && items[i].classList.contains('is-active')) return;
      current = i;
      items.forEach((it, n) => it.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => {
        d.classList.toggle('is-active', n === i);
        if (n === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = i + 1;
    };

    // stage: progress through the tall gallery wrapper picks the image
    const stageIndex = () => {
      const r = gallery.getBoundingClientRect();
      const sticky = $('.gallery__sticky', gallery).offsetHeight;
      const run = Math.max(1, r.height - sticky);
      const p = Math.min(0.999, Math.max(0, -r.top / run));
      return Math.floor(p * items.length);
    };
    // stack: the image whose middle is closest to the viewport middle
    const stackIndex = () => {
      const mid = window.innerHeight / 2;
      let best = 0;
      let dist = Infinity;
      items.forEach((it, n) => {
        const r = it.getBoundingClientRect();
        const d = Math.abs(r.top + r.height / 2 - mid);
        if (d < dist) {
          dist = d;
          best = n;
        }
      });
      return best;
    };
    // computed straight in the scroll handler: it is two rect reads, and it keeps
    // working even when the browser pauses animation frames
    // stage: slide position follows scroll continuously, with a short hold on each image
    const stageSlide = () => {
      const r = gallery.getBoundingClientRect();
      const sticky = $('.gallery__sticky', gallery).offsetHeight;
      const run = Math.max(1, r.height - sticky);
      const p = Math.min(1, Math.max(0, -r.top / run));
      const steps = items.length - 1;
      if (steps < 1) return 0;
      const raw = p * steps;
      const base = Math.floor(raw);
      const f = raw - base;
      // ease inside each step so images rest briefly before moving on
      const eased = f < 0.15 ? 0 : f > 0.85 ? 1 : (f - 0.15) / 0.7;
      const smooth = eased * eased * (3 - 2 * eased);
      return Math.min(steps, base + smooth);
    };
    const onScroll = () => {
      if (isStage()) {
        const pos = stageSlide();
        track.style.setProperty('--slide', pos.toFixed(4));
        setCurrent(Math.round(pos));
      } else if (desktop.matches) {
        setCurrent(stackIndex());
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // phones/tablets with the stack style: horizontal swipe
    track.addEventListener('scroll', () => {
      if (desktop.matches || isStage()) return;
      setCurrent(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
    }, { passive: true });

    const goTo = (i) => {
      const behavior = reduceMotion ? 'auto' : 'smooth';
      if (!desktop.matches && !isStage()) {
        track.scrollTo({ left: i * track.clientWidth, behavior });
      } else if (isStage()) {
        const top = window.scrollY + gallery.getBoundingClientRect().top;
        const run = gallery.offsetHeight - $('.gallery__sticky', gallery).offsetHeight;
        const steps = Math.max(1, items.length - 1);
        window.scrollTo({ top: top + run * (i / steps), behavior });
      } else {
        items[i].scrollIntoView({ behavior, block: 'start' });
      }
    };
    dots.forEach((d) => d.addEventListener('click', () => goTo(Number(d.dataset.galleryGo) - 1)));
    const next = $('[data-gallery-next]', gallery);
    if (next) next.addEventListener('click', () => goTo((current + 1) % items.length));
    document.addEventListener('variant:change', (e) => {
      const id = e.detail.variant.media;
      if (!id) return;
      const i = items.findIndex((it) => it.dataset.mediaId === String(id));
      if (i >= 0) goTo(i);
    });
    onScroll();
  }

  /* ---------- Cart (AJAX) ---------- */
  async function renderCart(sectionsHtml) {
    const html = sectionsHtml && sectionsHtml['cart-drawer'];
    const drawer = $('#CartDrawer');
    if (!html || !drawer) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawer');
    if (fresh) drawer.innerHTML = fresh.innerHTML;
    const count = doc.querySelector('.cart-drawer__count');
    const n = count ? parseInt(count.textContent.replace(/\D/g, ''), 10) || 0 : 0;
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  async function addToCart(form) {
    const btn = $('[data-add-button]', form);
    const err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      const res = await fetch(`${routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
      // the animation is decoration: never let it hold up the cart (it pauses in background tabs)
      await Promise.race([flyToCart(form), new Promise((r) => setTimeout(r, 750))]);
      await renderCart(json.sections);
      const quick = form.closest('[data-quick-dialog]');
      if (quick) closeDialog(quick);
      if (window.theme.cartType === 'drawer') openDialog($('#CartDrawer'), quick ? null : btn);
      else window.location.href = routes.cart;
    } catch (e) {
      if (err) {
        err.textContent = e.message;
        err.hidden = false;
      }
    } finally {
      btn && btn.removeAttribute('aria-busy');
    }
  }

  /* the product image shrinks into the cart icon, then the icon bumps */
  function flyToCart(form) {
    const cart = $('.header__cart');
    const product = form.closest('[data-product]');
    const src = $('[data-fly-src]', form) || (product && ($('.gallery__item.is-active .gallery__img', product) || $('.gallery__img', product)));
    if (reduceMotion || !cart || !src || !src.animate) return Promise.resolve();
    const from = src.getBoundingClientRect();
    const to = cart.getBoundingClientRect();
    if (!from.width || to.bottom < 0) return Promise.resolve();
    const fly = document.createElement('img');
    fly.src = src.currentSrc || src.src;
    fly.alt = '';
    fly.className = 'fly-image';
    Object.assign(fly.style, { left: from.left + 'px', top: from.top + 'px', width: from.width + 'px', height: from.height + 'px' });
    document.body.appendChild(fly);
    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);
    const anim = fly.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.6}px, ${dy * 0.35}px) scale(0.45)`, opacity: 1, offset: 0.55 },
        { transform: `translate(${dx}px, ${dy}px) scale(0.06)`, opacity: 0.4 },
      ],
      { duration: 650, easing: 'cubic-bezier(0.5, 0, 0.2, 1)' }
    );
    setTimeout(() => fly.remove(), 1000);
    return anim.finished
      .then(() => {
        fly.remove();
        cart.classList.remove('is-bumping');
        void cart.offsetWidth;
        cart.classList.add('is-bumping');
      })
      .catch(() => fly.remove());
  }

  async function changeQty(key, quantity) {
    const drawer = $('#CartDrawer');
    drawer && drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer', sections_url: window.location.pathname }),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || 'Could not update cart');
      await renderCart(json.sections);
    } catch (e) {
      toast(e.message);
    } finally {
      drawer && drawer.classList.remove('is-loading');
    }
  }

  // account menu: close when clicking elsewhere or pressing Escape
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-account-close]');
    if (closeBtn) closeBtn.closest('[data-account-menu]').removeAttribute('open');
    $$('[data-account-menu][open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('[data-account-menu][open]').forEach((d) => d.removeAttribute('open'));
  });

  // country / currency: switch as soon as one is picked
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-country-select]');
    if (select) select.form.submit();
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    addToCart(form);
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    changeQty(b.dataset.key, Number(b.dataset.qtyChange));
  });

  /* ---------- Lightbox: click a gallery image to view it full screen, click again to zoom ---------- */
  function initLightbox() {
    const box = $('[data-lightbox]');
    if (!box) return;
    const track = $('[data-lightbox-track]', box);
    // measured on the unscaled container: the zoomed image's own rect is 2.2x larger
    const origin = (img, e) => {
      const r = img.parentElement.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    };
    document.addEventListener('click', (e) => {
      const img = e.target.closest('.gallery__img');
      if (!img) return;
      const item = img.closest('[data-media-id]');
      $$('.is-zoomed', box).forEach((i) => i.classList.remove('is-zoomed'));
      openDialog(box, img);
      const target = item && $(`.lightbox__item[data-media-id="${item.dataset.mediaId}"]`, box);
      if (target) track.scrollLeft = target.offsetLeft;
    });
    box.addEventListener('click', (e) => {
      const img = e.target.closest('.lightbox__img');
      if (!img) return;
      if (!img.classList.contains('is-zoomed')) origin(img, e);
      img.classList.toggle('is-zoomed');
    });
    box.addEventListener('mousemove', (e) => {
      const img = e.target.closest('.lightbox__img.is-zoomed');
      if (img) origin(img, e);
    });
    box.addEventListener('close', () => $$('.is-zoomed', box).forEach((i) => i.classList.remove('is-zoomed')));
  }

  /* ---------- Tap-to-reveal discount code ---------- */
  const SCRAMBLE = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  function scrambleIn(el, finalText) {
    if (reduceMotion) {
      el.textContent = finalText;
      return;
    }
    let frame = 0;
    const total = 14;
    const tick = () => {
      frame += 1;
      const settled = Math.floor((frame / total) * finalText.length);
      el.textContent = finalText
        .split('')
        .map((ch, i) => (i < settled || ch === ' ' ? ch : SCRAMBLE[Math.floor(Math.random() * SCRAMBLE.length)]))
        .join('');
      if (frame < total) setTimeout(tick, 40);
      else el.textContent = finalText;
    };
    tick();
  }
  document.addEventListener('click', async (e) => {
    const reveal = e.target.closest('[data-promo-reveal]');
    if (reveal) {
      const box = reveal.closest('[data-promo]');
      box.classList.add('is-open');
      reveal.setAttribute('aria-expanded', 'true');
      $('.promo__open', box).setAttribute('aria-hidden', 'false');
      const copy = $('[data-promo-copy]', box);
      copy.tabIndex = 0;
      scrambleIn($('[data-promo-code]', box), box.dataset.code);
      copy.focus({ preventScroll: true });
      return;
    }
    const copyBtn = e.target.closest('[data-promo-copy]');
    if (copyBtn) {
      const box = copyBtn.closest('[data-promo]');
      const label = $('[data-promo-copy-label]', box);
      const status = $('[data-promo-status]', box);
      try {
        await navigator.clipboard.writeText(box.dataset.code);
        box.classList.add('is-copied');
        label.textContent = 'Copied';
        if (status) status.textContent = 'Discount code copied';
        setTimeout(() => {
          box.classList.remove('is-copied');
          label.textContent = 'Copy';
        }, 1800);
      } catch (err) {
        // clipboard blocked: select the code so the shopper can copy it by hand
        const range = document.createRange();
        range.selectNodeContents($('[data-promo-code]', box));
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  });

  /* ---------- Collection tabs: sliding pill + products rise in one by one ---------- */
  function initCollectionTabs() {
    $$('[data-ctabs]').forEach((root) => {
      const tabs = $$('[role="tab"]', root);
      const indicator = $('[data-ctabs-indicator]', root);
      const move = (tab) => {
        if (!indicator) return;
        indicator.style.width = tab.offsetWidth + 'px';
        indicator.style.transform = `translateX(${tab.offsetLeft}px)`;
      };
      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          panel.classList.toggle('is-active', on);
          if (on) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        });
        move(tab);
        if (focus) tab.focus();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(next, true);
        });
      });
      const active = tabs.find((t) => t.classList.contains('is-active')) || tabs[0];
      if (active) move(active);
      window.addEventListener('resize', () => move(tabs.find((t) => t.classList.contains('is-active'))));
    });
  }

  /* ---------- Quick view: the panel expands out of the card, content blurs in ---------- */
  function initQuickView() {
    const dialog = $('[data-quick-dialog]');
    if (!dialog) return;
    const body = $('[data-quick-body]', dialog);
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      const card = btn.closest('.card');
      const from = ($('.card__media', card) || card).getBoundingClientRect();
      body.innerHTML = '';
      body.classList.add('is-loading');
      dialog.classList.add('is-expanding');
      openDialog(dialog, btn);
      if (!reduceMotion && dialog.animate) {
        const to = dialog.getBoundingClientRect();
        dialog.animate(
          [
            { transform: `translate(${from.left - to.left}px, ${from.top - to.top}px) scale(${from.width / to.width}, ${from.height / to.height})`, borderRadius: '0px' },
            { transform: 'none', borderRadius: '16px' },
          ],
          { duration: 480, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
      }
      try {
        const url = btn.dataset.quickView + (btn.dataset.quickView.includes('?') ? '&' : '?') + 'section_id=quick-view';
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const quick = doc.querySelector('[data-quick]');
        body.classList.remove('is-loading');
        if (!quick) throw new Error('missing');
        body.appendChild(quick);
        initProduct(quick);
      } catch (err) {
        body.classList.remove('is-loading');
        window.location.href = btn.dataset.quickView;
        return;
      }
      requestAnimationFrame(() => dialog.classList.remove('is-expanding'));
      setTimeout(() => dialog.classList.remove('is-expanding'), 60);
    });
  }

  /* ---------- Hero logo: starts big in the middle of the hero, glides into the header ---------- */
  function initLogoMorph() {
    const hero = $('#MainContent > .shopify-section:first-child [data-logo-morph]');
    const header = $('[data-header]');
    const slot = header && $('.header__logo', header);
    if (!hero || !slot || !header.hasAttribute('data-over-hero') || reduceMotion) return;
    const root = document.documentElement;
    const veil = $('.hero__veil', hero);
    // 'intro': the logo starts big in the middle and glides into the header by itself
    // 'docked': it already sits in the header; 'scroll': it follows the scroll (no intro)
    let mode = 'scroll';
    if (veil) mode = root.classList.contains('hero-intro') && window.scrollY <= 40 ? 'intro' : 'docked';
    let forced = mode === 'intro' ? 0 : 1;
    let rest = null;

    // e: 0 = big in the middle of the hero, 1 = in the header
    const place = (e) => {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const big = Math.min((vw * (vw < 750 ? 0.6 : 0.42)) / rest.w, (vh * 0.22) / rest.h);
      const scale = 1 + (big - 1) * (1 - e);
      const targetY = Math.min(hero.offsetHeight, vh) / 2;
      const dy = (targetY - (rest.cy - window.scrollY)) * (1 - e);
      slot.style.transform = e >= 1 ? '' : `translate3d(0, ${dy.toFixed(1)}px, 0) scale(${scale.toFixed(3)})`;
      slot.classList.toggle('is-morphing', e < 1);
    };
    const update = () => {
      if (!rest) return;
      if (mode !== 'scroll') return place(forced);
      const p = Math.min(1, Math.max(0, window.scrollY / (hero.offsetHeight * 0.45)));
      place(1 - Math.pow(1 - p, 3));
    };
    const measure = () => {
      slot.style.transform = '';
      const r = slot.getBoundingClientRect();
      rest = { cx: r.left + r.width / 2, cy: r.top + r.height / 2 + window.scrollY, w: r.width, h: r.height };
      update();
    };

    const runIntro = () => {
      const timers = [];
      let raf = 0;
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        timers.forEach(clearTimeout);
        cancelAnimationFrame(raf);
        mode = 'docked';
        forced = 1;
        update();
        root.classList.remove('hero-intro', 'hero-intro-skip');
        // land on the main logo; it only keeps cycling if the theme is set to loop
        document.dispatchEvent(new CustomEvent('logo:lock'));
        document.dispatchEvent(new CustomEvent('logo:release'));
      };
      document.dispatchEvent(new CustomEvent('logo:fast'));
      // settle on the main logo, hold it, then the blur clears (1.8s in CSS)
      timers.push(setTimeout(() => document.dispatchEvent(new CustomEvent('logo:lock')), 1400));
      // the logo keeps cycling the whole way; it glides up as the blur clears (1.2s in CSS):
      // slow start, quick middle, soft landing
      timers.push(
        setTimeout(() => {
          const start = performance.now();
          const step = (now) => {
            const k = Math.min(1, (now - start) / 1000);
            forced = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
            update();
            if (k < 1) raf = requestAnimationFrame(step);
            else finish();
          };
          raf = requestAnimationFrame(step);
        }, 1800)
      );
      // animation frames pause in background tabs: never leave the logo stuck in the middle
      timers.push(setTimeout(finish, 3600));
      // scrolling during the intro: wrap it up quickly but smoothly instead of jumping
      const skip = () => {
        if (done) return;
        timers.forEach(clearTimeout);
        cancelAnimationFrame(raf);
        document.dispatchEvent(new CustomEvent('logo:lock'));
        root.classList.add('hero-intro-skip');
        const from = forced;
        const start = performance.now();
        const step = (now) => {
          const k = Math.min(1, (now - start) / 450);
          forced = from + (1 - from) * (1 - Math.pow(1 - k, 3));
          update();
          if (k < 1) raf = requestAnimationFrame(step);
          else finish();
        };
        raf = requestAnimationFrame(step);
        timers.push(setTimeout(finish, 700));
      };
      window.addEventListener('scroll', skip, { once: true, passive: true });
    };
    if (mode === 'intro') runIntro();
    // enter screen: the intro plays as the shopper swipes in
    document.addEventListener(
      'enter:open',
      () => {
        if (!veil || mode === 'intro' || window.scrollY > 40) return;
        root.classList.add('hero-intro');
        mode = 'intro';
        forced = 0;
        update();
        runIntro();
      },
      { once: true }
    );

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);
    if (document.readyState === 'complete') measure();
    else window.addEventListener('load', measure, { once: true });
    measure();
  }

  /* ---------- Curtain page transition ----------
     Leaving: the curtain rises, then we navigate. Arriving: the page starts covered (set in <head>)
     and the curtain lifts away while the content rises in. */
  // shared rule for which clicks count as an in-store page change
  const transitionLink = (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return null;
    const a = e.target.closest('a[href]');
    if (!a || a.target || a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return null;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return null;
    if (url.pathname === location.pathname && url.search === location.search) return null;
    if (/^\/(checkout|cart\/|account\/logout)/.test(url.pathname)) return null;
    return url;
  };

  function initGlideTransition() {
    const root = document.documentElement;
    try {
      sessionStorage.removeItem('unlock:pt');
    } catch (e) {}
    if (root.classList.contains('pt-in')) setTimeout(() => root.classList.remove('pt-in'), 900);
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) root.classList.remove('pt-out', 'pt-in');
    });
    document.addEventListener('click', (e) => {
      const url = transitionLink(e);
      if (!url) return;
      e.preventDefault();
      root.classList.add('pt-out');
      try {
        sessionStorage.setItem('unlock:pt', '1');
      } catch (err) {}
      setTimeout(() => (window.location.href = url.href), 280);
    });
  }

  /* ---------- Search sheet: drops from the top, live results while typing ---------- */
  function initSearch() {
    const sheet = $('[data-search-sheet]');
    if (!sheet) return;
    const input = $('[data-search-input]', sheet);
    const results = $('[data-search-results]', sheet);
    const suggest = $('[data-search-suggest]', sheet);
    const routes = (window.theme && window.theme.routes) || {};
    let timer = null;
    let controller = null;

    $$('[data-search-open]').forEach((opener) =>
      opener.addEventListener('click', (e) => {
        e.preventDefault();
        // the menu drawer may be open when search is picked from it
        $$('dialog[open]').forEach((d) => d !== sheet && closeDialog(d));
        openDialog(sheet, opener);
        requestAnimationFrame(() => input.focus());
        setTimeout(() => input.focus(), 60);
      })
    );

    const render = async (q) => {
      if (controller) controller.abort();
      if (!q) {
        results.innerHTML = '';
        if (suggest) suggest.hidden = false;
        return;
      }
      controller = new AbortController();
      const url = `${routes.predictiveSearch || '/search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,query&resources[limit]=6&resources[options][fields]=title,product_type,tag,variants.title&section_id=predictive-search`;
      try {
        const res = await fetch(url, { signal: controller.signal });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const box = doc.querySelector('[data-psearch-results]');
        results.innerHTML = box ? box.outerHTML : '';
        // keep the popular terms on screen when nothing matched
        if (suggest) suggest.hidden = !!box && box.dataset.count !== '0';
      } catch (err) {
        if (err.name !== 'AbortError') results.innerHTML = '';
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => render(input.value.trim()), 180);
    });

    // recently viewed: product pages remember themselves (newest first, up to 4)
    const KEY = 'unlock:recent';
    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(KEY)) || [];
      } catch (e) {
        return [];
      }
    };
    const page = $('[data-recent-url]');
    if (page) {
      const item = {
        url: page.dataset.recentUrl,
        title: JSON.parse($('[data-recent-item]').textContent),
        image: page.dataset.recentImage,
        price: page.dataset.recentPrice,
      };
      try {
        localStorage.setItem(KEY, JSON.stringify([item, ...read().filter((r) => r.url !== item.url)].slice(0, 4)));
      } catch (e) {}
    }
    const recent = $('[data-recent]', sheet);
    const list = $('[data-recent-list]', sheet);
    const fill = () => {
      const items = read().filter((r) => !page || r.url !== page.dataset.recentUrl);
      recent.hidden = !items.length;
      list.innerHTML = '';
      items.forEach((r) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = r.url;
        const img = document.createElement('img');
        img.src = r.image;
        img.alt = '';
        img.loading = 'lazy';
        const name = document.createElement('span');
        name.className = 'recent__name';
        name.textContent = r.title;
        const price = document.createElement('span');
        price.className = 'recent__price';
        price.textContent = r.price;
        a.append(img, name, price);
        li.append(a);
        list.append(li);
      });
    };
    if (recent) {
      fill();
      $('[data-recent-clear]', sheet).addEventListener('click', () => {
        try {
          localStorage.removeItem(KEY);
        } catch (e) {}
        fill();
      });
    }
  }

  /* ---------- Shop panel: the category under the pointer shows its pieces ---------- */
  function initMega() {
    $$('[data-mega]').forEach((mega) => {
      const cats = $$('[data-mega-cat]', mega);
      const groups = $$('[data-mega-group]', mega);
      const show = (i) => {
        cats.forEach((c, n) => c.classList.toggle('is-active', n === i));
        groups.forEach((g, n) => g.classList.toggle('is-active', n === i));
      };
      cats.forEach((c, i) => {
        c.addEventListener('mouseenter', () => show(i));
        c.addEventListener('focus', () => show(i));
      });
    });
  }

  /* ---------- Reviews: arrows, counter, tap a floating portrait to read that review ---------- */
  function initReviews() {
    $$('[data-reviews]').forEach((box) => {
      const items = $$('[data-review]', box);
      const floats = $$('[data-review-go]', box);
      const counter = $('[data-review-current]', box);
      if (items.length < 2) return;
      let i = 0;
      const show = (n) => {
        i = (n + items.length) % items.length;
        items.forEach((it, k) => (it.hidden = k !== i));
        floats.forEach((f, k) => f.classList.toggle('is-active', k === i));
        if (counter) counter.textContent = i + 1;
      };
      $('[data-review-prev]', box).addEventListener('click', () => show(i - 1));
      $('[data-review-next]', box).addEventListener('click', () => show(i + 1));
      floats.forEach((f, k) => f.addEventListener('click', () => show(k)));
    });
  }

  /* ---------- Models rail: arrows scroll the row by about one screen ---------- */
  function initModelRail() {
    $$('[data-model-rail]').forEach((rail) => {
      const track = $('[data-rail-track]', rail);
      const prev = $('[data-rail-prev]', rail);
      const next = $('[data-rail-next]', rail);
      if (!track || !prev || !next) return;
      const step = () => Math.max(track.clientWidth * 0.8, 240);
      const sync = () => {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function initPageTransition() {
    if (window.theme && window.theme.pageTransition === 'glide') return initGlideTransition();
    const pt = $('[data-pt]');
    if (!pt) return;
    const root = document.documentElement;
    const frames = [...$$('.pt__logo--alt', pt), ...$$('.pt__logo--main', pt)];
    let flashTimer = null;
    // flick through the logos like switching TV channels, then rest on the main logo
    const channelSwitch = (startAt = 0) => {
      clearInterval(flashTimer);
      let i = startAt;
      const show = () => {
        frames.forEach((f, n) => f.classList.toggle('is-on', n === i));
      };
      show();
      flashTimer = setInterval(() => {
        i += 1;
        if (i >= frames.length) return clearInterval(flashTimer);
        show();
      }, 95);
    };
    try {
      sessionStorage.removeItem('unlock:pt');
    } catch (e) {}
    if (root.classList.contains('pt-cover')) {
      // arriving: the main logo is already showing, as the leaving page ended on it
      frames.forEach((f) => f.classList.toggle('is-on', f.classList.contains('pt__logo--main')));
      const lift = () => {
        root.classList.remove('pt-entering');
        void pt.offsetWidth;
        root.classList.add('pt-lifting');
        root.classList.remove('pt-cover');
        setTimeout(() => root.classList.remove('pt-lifting'), 900);
      };
      // wait for the logo frame to paint, but never hold the page
      if (document.readyState === 'complete') setTimeout(lift, 120);
      else window.addEventListener('load', () => setTimeout(lift, 60), { once: true });
      setTimeout(() => root.classList.contains('pt-cover') && lift(), 1500);
    }
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) root.classList.remove('pt-cover', 'pt-entering', 'pt-lifting');
    });
    document.addEventListener('click', (e) => {
      const url = transitionLink(e);
      if (!url) return;
      e.preventDefault();
      root.classList.add('pt-cover');
      setTimeout(() => channelSwitch(0), 220);
      try {
        sessionStorage.setItem('unlock:pt', '1');
      } catch (err) {}
      setTimeout(() => (window.location.href = url.href), 600);
    });
  }

  /* ---------- Size guide: units + selected size ---------- */
  function initSizeGuide() {
    const dlg = $('[data-size-guide]');
    if (!dlg) return;
    $$('[data-unit]', dlg).forEach((btn) =>
      btn.addEventListener('click', () => {
        const unit = btn.dataset.unit;
        $$('[data-unit]', dlg).forEach((b) => {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', String(b === btn));
        });
        $$('td[data-cm]', dlg).forEach((td) => {
          const cm = parseFloat(td.dataset.cm);
          td.textContent = isNaN(cm) ? td.dataset.cm : unit === 'in' ? (Math.round((cm / 2.54) * 10) / 10).toString() : td.dataset.cm;
        });
      })
    );
    const ALIASES = { xs: 'xs', 'x-small': 'xs', s: 's', small: 's', m: 'm', medium: 'm', l: 'l', large: 'l', xl: 'xl', 'x-large': 'xl', xxl: 'xxl', '2xl': 'xxl', 'xxl-large': 'xxl' };
    const norm = (v) => {
      const k = String(v || '').trim().toLowerCase();
      return ALIASES[k] || k;
    };
    const highlight = () => {
      const selected = $$('[data-variant-picker] input:checked').map((i) => norm(i.value));
      $$('tr[data-size]', dlg).forEach((tr) => tr.classList.toggle('is-selected', selected.includes(norm(tr.dataset.size))));
    };
    dlg.addEventListener('toggle', highlight);
    document.addEventListener('variant:change', highlight);
    $$('[data-dialog-open="SizeGuide"]').forEach((b) => b.addEventListener('click', highlight));
  }

  /* ---------- Related products ---------- */
  async function initRelated() {
    const box = $('[data-related]');
    if (!box) return;
    try {
      const res = await fetch(box.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = doc.querySelector('.grid');
      if (!grid) return;
      $('[data-related-target]', box).replaceWith(grid);
      box.hidden = false;
    } catch (e) {}
  }

  /* ---------- Grid image flows into the product page ---------- */
  function initImageTransition() {
    if (reduceMotion) return;
    // outgoing page: name the clicked card image
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.card__link');
      if (!link) return;
      const media = $('[data-vt-product]', link);
      const img = media && $('.card__img', media);
      if (!img) return;
      img.style.viewTransitionName = 'product-image';
      try {
        sessionStorage.setItem('unlock:vt', media.dataset.vtProduct);
      } catch (err) {}
    });
    // incoming page: give the first gallery image the same name
    window.addEventListener('pagereveal', (e) => {
      if (!e.viewTransition) return;
      let id = null;
      try {
        id = sessionStorage.getItem('unlock:vt');
        sessionStorage.removeItem('unlock:vt');
      } catch (err) {}
      const img = id && document.querySelector(`.gallery__item[data-vt-product="${id}"] .gallery__img`);
      if (!img) return;
      img.style.viewTransitionName = 'product-image';
      e.viewTransition.finished.finally(() => (img.style.viewTransitionName = ''));
    });
    // back/forward: clear names left on cards
    window.addEventListener('pageshow', () => $$('.card__img').forEach((i) => (i.style.viewTransitionName = '')));
  }
  initImageTransition();

  /* ---------- Countdown (password page) ---------- */
  function initCountdown() {
    $$('[data-countdown]').forEach((el) => {
      const end = Date.parse(el.dataset.countdown);
      if (isNaN(end)) return;
      const live = el.parentElement.querySelector('[data-countdown-live]');
      const units = { d: 86400, h: 3600, m: 60, s: 1 };
      const tick = () => {
        let left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        Object.entries(units).forEach(([k, size]) => {
          const n = $(`[data-unit="${k}"]`, el);
          const v = Math.floor(left / size);
          left -= v * size;
          if (n) n.textContent = String(v).padStart(2, '0');
        });
        if (end <= Date.now()) {
          el.classList.add('is-live');
          if (live) live.hidden = false;
          return false;
        }
        return true;
      };
      if (tick()) {
        const id = setInterval(() => tick() || clearInterval(id), 1000);
      }
    });
  }

  /* ---------- Enter screen (home) ---------- */
  function initEnter() {
    const gate = $('[data-enter]');
    if (!gate) return;
    const root = document.documentElement;
    if (!root.classList.contains('gate-on')) {
      gate.remove();
      return;
    }
    let done = false;
    let startY = null;
    let dy = 0;
    let t0 = 0;
    let moved = 0;
    let wheel = 0;
    let pid = null;
    const set = (y) => {
      gate.style.setProperty('--y', y + 'px');
      gate.style.setProperty('--p', Math.min(1, -y / window.innerHeight).toFixed(3));
    };
    const finish = () => {
      root.classList.remove('gate-on');
      gate.remove();
      document.removeEventListener('keydown', onKey);
    };
    const leave = () => {
      if (done) return;
      done = true;
      try {
        sessionStorage.setItem('unlock:entered', '1');
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('enter:open'));
      if (reduceMotion) return finish();
      gate.classList.remove('is-dragging', 'is-settling');
      gate.classList.add('is-leaving');
      gate.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 1000);
    };
    // drag the screen up with a finger or the mouse; let go past a quarter (or flick) to open
    gate.addEventListener('pointerdown', (e) => {
      if (done || e.button > 0 || startY !== null) return;
      pid = e.pointerId;
      startY = e.clientY;
      t0 = performance.now();
      dy = 0;
      moved = 0;
      gate.classList.remove('is-settling');
      gate.classList.add('is-dragging');
      try {
        gate.setPointerCapture(e.pointerId);
      } catch (err) {}
    });
    gate.addEventListener('pointermove', (e) => {
      if (startY === null || done || e.pointerId !== pid) return;
      const raw = e.clientY - startY;
      moved = Math.max(moved, Math.abs(raw));
      // pulling down only gives a little, like a real lock screen
      dy = raw < 0 ? raw : raw * 0.15;
      set(dy);
    });
    const release = (e) => {
      if (startY === null || done || e.pointerId !== pid) return;
      startY = null;
      pid = null;
      gate.classList.remove('is-dragging');
      const speed = dy / Math.max(1, performance.now() - t0);
      if (-dy > window.innerHeight * 0.25 || (dy < -30 && speed < -0.5)) return leave();
      gate.classList.add('is-settling');
      set(0);
    };
    gate.addEventListener('pointerup', release);
    gate.addEventListener('pointercancel', release);
    // stop the browser's own drag-and-drop from cancelling the swipe halfway
    gate.addEventListener('dragstart', (e) => e.preventDefault());
    gate.addEventListener('mousedown', (e) => e.preventDefault());
    // a tap on the hint opens it straight away (no drag needed)
    $('[data-enter-go]', gate).addEventListener('click', () => {
      if (moved < 8) leave();
    });
    // mouse wheel / trackpad: scrolling down opens it
    gate.addEventListener(
      'wheel',
      (e) => {
        e.preventDefault();
        if (e.deltaY > 0) wheel += e.deltaY;
        if (wheel > 60) leave();
      },
      { passive: false }
    );
    function onKey(e) {
      if (['Enter', ' ', 'ArrowUp', 'ArrowDown', 'PageDown'].includes(e.key)) {
        e.preventDefault();
        leave();
      }
    }
    document.addEventListener('keydown', onKey);
  }

  /* ---------- Header menu: links that do not fit go into "More" (tablets) ---------- */
  function initNavMore() {
    const nav = $('.header__nav');
    const more = nav && $('[data-menu-more]', nav);
    if (!more) return;
    const list = $('[data-menu-more-list]', more);
    const btn = $('[data-menu-more-btn]', more);
    const items = $$('.header__menu > .header__menu-item:not([data-menu-more])', nav);
    const close = () => {
      more.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    };
    const fit = () => {
      close();
      items.forEach((li) => (li.hidden = false));
      list.innerHTML = '';
      more.hidden = true;
      if (!nav.offsetParent) return; // phones: the menu lives in the drawer
      const ul = more.parentElement;
      // where the last visible link ends (dropdowns hanging below do not count)
      const over = () => {
        const shown = [...ul.children].filter((li) => !li.hidden);
        const last = shown[shown.length - 1];
        return last ? last.getBoundingClientRect().right - nav.getBoundingClientRect().right > 1 : false;
      };
      if (!over()) return;
      more.hidden = false;
      // hide links from the end until the row fits next to "More"
      for (let i = items.length - 1; i >= 0 && over(); i--) {
        items[i].hidden = true;
      }
      items
        .filter((li) => li.hidden)
        .forEach((li) => {
          const a = $('.header__link', li);
          const row = document.createElement('li');
          row.innerHTML = `<a class="header__sublink" href="${a.getAttribute('href')}"></a>`;
          row.firstChild.textContent = a.textContent.trim();
          list.appendChild(row);
        });
    };
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = !more.classList.contains('is-open');
      more.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', (e) => {
      if (!more.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && more.classList.contains('is-open')) {
        close();
        btn.focus();
      }
    });
    if ('ResizeObserver' in window) new ResizeObserver(() => fit()).observe(nav);
    else window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
  }

  /* ---------- Back button ---------- */
  function initBack() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-back]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
      let sameSite = false;
      try {
        sameSite = !!document.referrer && new URL(document.referrer).origin === window.location.origin;
      } catch (err) {}
      if (sameSite && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
    });
  }

  /* ---------- Announcement bar: messages take turns; the fixed home header sits below it ---------- */
  function initAnnounce() {
    const bar = $('[data-announce]');
    const root = document.documentElement;
    if (!bar) return;
    const msgs = $$('.announce__msg', bar);
    if (msgs.length > 1 && !reduceMotion) {
      const ms = (parseFloat(getComputedStyle(bar).getPropertyValue('--announce-speed')) || 5) * 1000;
      let i = 0;
      setInterval(() => {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, ms);
    }
    const offset = () => {
      const h = bar.getBoundingClientRect().bottom;
      root.style.setProperty('--announce-offset', Math.max(0, h) + 'px');
    };
    window.addEventListener('scroll', offset, { passive: true });
    window.addEventListener('resize', offset);
    offset();
  }

  // each part starts on its own: one failure must never stop the rest (e.g. leave the loader covering the page)
  document.addEventListener('DOMContentLoaded', () => {
    [initPageTransition, initHeader, initLogoCycle, initHero, initCollection, initProduct, initSizeGuide, initLightbox, initCollectionTabs, initLogoMorph, initQuickView, initRelated, initSearch, initMega, initReviews, initModelRail, initCountdown, initEnter, initNavMore, initBack, initAnnounce].forEach((fn) => {
      try {
        fn();
      } catch (err) {
        console.error('[theme] ' + fn.name + ' failed', err);
      }
    });
  });
})();
